// Evidence-import provenance banner — PURE PRESENTATIONAL (no runtime/services import).
// Shown when the canvas strategy was loaded from a published Evidence candidate; renders
// its verdict vocabulary verbatim and links the sealed artifact. History, not a promise.
import React from 'react';
import { useStrategy } from '../../contexts/StrategyContext';

interface EvidenceImportMeta {
  source: 'evidence-showcase' | 'evidence-strict';
  id: string;
  verdict: string;
  provenance?: { artifactHref?: string; paramHash?: string | null };
}

export const EvidenceImportBanner: React.FC = () => {
  const { meta, strategySource } = useStrategy();
  if (strategySource !== 'evidence-import') return null;
  const info = (meta as { evidenceImport?: EvidenceImportMeta } | undefined)?.evidenceImport;
  if (!info) return null;
  const strict = info.source === 'evidence-strict';
  return (
    <div className={`rounded-lg border px-3 py-2 text-xs mb-2 ${strict ? 'border-emerald-200 bg-emerald-50 text-emerald-900' : 'border-violet-200 bg-violet-50 text-violet-900'}`}>
      <b>Imported from the Evidence page:</b>{' '}
      <span className="font-mono">{info.id}</span> — {info.verdict}
      {strict
        ? ' on its one-shot confirmation windows.'
        : ' in a bounded subscriber-style showcase run.'}{' '}
      {info.provenance?.artifactHref && (
        <a className="underline" href={info.provenance.artifactHref} target="_blank" rel="noopener noreferrer">
          sealed artifact
        </a>
      )}{' '}
      <span className="opacity-75">
        The published-evidence reproduction lives in the sealed artifact (build-time comparison, byte-identical
        trade ledgers on the sealed fixture). <b>Run Current Backtest</b> on the Evidence page presets the full
        published configuration for a NEW run on current data — which may differ and does not validate the
        published evidence. Past results never guarantee future returns.
      </span>
    </div>
  );
};
